export default "__VITE_ASSET__CuMIih$r__"